export default "__VITE_ASSET__c590a613__"